<script setup>
import { defineProps } from "vue";
import { AisRangeInput } from "vue-instantsearch/vue3/es";
import AlgoliaDateSearch from "@/components/ExperiencePage/Algolia/widgets/AlgoliaIndividualDateSearch/index.vue";

const props = defineProps({
  filterAttribute: {
    type: String,
  },
});
</script>

<template>
  <ais-range-input :attribute="props.filterAttribute" :precision="1">
    <template #default="{ currentRefinement, range, refine, canRefine }">
      <AlgoliaDateSearch
        :current-refinement="currentRefinement"
        :range="range"
        :refine="refine"
        :can-refine="canRefine"
      />
    </template>
  </ais-range-input>
</template>

